var bantBind = { data: '=' };
var BantFormTableController = (function () {
    function BantFormTableController(topic, socket, $scope, env) {
        this.topic = topic;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.tableName = 'Eligibility Decisions Checklist';
        this.comp = 'complcl4';
        this.visible = false;
        this.data = this.data || [];
    }
    BantFormTableController.prototype.toggle = function () {
        this.visible = !this.visible;
        var bantLabels = {
            activitiesDescription: '6. Account url',
            activitiesPerformed: '5. Activities Performed',
            additionalInformation: '7. Additional information',
            contactEmail: '9. Contact Email',
            contactName: '8. Contact Name',
            hasItalianPublicTender: '10. Italian Public Tender',
            hasPreviousOpportunity: '3. Re-registration',
            isGEProcurement: '11. AP GE Procurement Request',
            meetingRequirement: '4. Meeting Requirement',
            previousOpportunityNumber: '3a. Please enter the previous opportunity number',
            problemDescription: '1. Problem Description',
            pronunciation: '8a. Pronunciation',
            solutionBenefit: '2. Solution Value'
        };
        this.data = this.data.filter(function (elem) { return bantLabels[elem.name] && elem.value !== ''; });
        this.data.forEach(function (elem) {
            elem.shortDescription = bantLabels[elem.name];
            elem.questionNumber = parseInt(elem.shortDescription, 10);
            if (['activitiesPerformed', 'meetingRequirement'].includes(elem.name)) {
                elem.value = elem.value === true ? 'Confirmed' : 'Not Confirmed';
                elem.label = elem.name === 'activitiesPerformed'
                    ? 'Please confirm that your company has or will participate in value-add or technical activities with your customer regarding this opportunity and that you will provide evidence of these activities open request.'
                    : 'Please confirm that an in-person meeting or conference call has taken place between your company, your Customer\'s software decision-maker, or between your company and the IBM Direct Client team or Channel team in regards to this opportunity.';
            }
        });
        this.data = this.data.filter(function (elem) { return angular.isDefined(elem.value); });
    };
    BantFormTableController.$inject = ['topic', 'socket', '$scope', 'env'];
    return BantFormTableController;
}());
// tslint:disable-next-line:max-classes-per-file
var BantFormComponent = (function () {
    function BantFormComponent() {
        this.templateUrl = 'detail-table-bant-form.html';
        this.controllerAs = 'vm';
        this.controller = BantFormTableController;
        this.bindings = bantBind;
    }
    return BantFormComponent;
}());
angular
    .module('application')
    .component('bantFormTable', new BantFormComponent());

//# sourceMappingURL=detail.bant.form.component.js.map
